import React, { useContext } from 'react';
import styled from 'styled-components';

import { Icon } from 'components';
import TourEditContext from '../TourEditContext';
import { OptimizeStatus } from '../types';
import MobileFriendlyTooltip from '../MobileFriendlyTooltip';

const RouteModeActions: React.FC = () => {
  const { setOptimizeStatus, travelMode, setTravelMode } =
    useContext(TourEditContext);

  const toggleTravelMode = (newMode: google.maps.TravelMode) => {
    setTravelMode(newMode);
    setOptimizeStatus(OptimizeStatus.NOT_OPTIMIZED);
  };

  return (
    <>
      <MobileFriendlyTooltip title="Driving">
        <StyledIconButton
          $active={travelMode === google.maps.TravelMode.DRIVING}
          onClick={() => toggleTravelMode(google.maps.TravelMode.DRIVING)}
          data-cy="tours-driving-button"
        >
          <Icon
            type="car"
            color={
              travelMode === google.maps.TravelMode.DRIVING ? 'info' : 'black'
            }
            width={14}
            offset={[0, -2]}
          />
        </StyledIconButton>
      </MobileFriendlyTooltip>
      <MobileFriendlyTooltip title="Walking">
        <StyledIconButton
          $active={travelMode === google.maps.TravelMode.WALKING}
          onClick={() => toggleTravelMode(google.maps.TravelMode.WALKING)}
          data-cy="tours-walking-button"
        >
          <Icon
            type="walking"
            color={
              travelMode === google.maps.TravelMode.WALKING ? 'info' : 'black'
            }
            width={14}
            offset={[0, -2]}
          />
        </StyledIconButton>
      </MobileFriendlyTooltip>
    </>
  );
};

export default RouteModeActions;

// NOTE: did not use Button from components, too many styles to override and we don't need the consisten UI for this case
const StyledIconButton = styled.button<{
  $active: boolean;
}>`
  border: 1px solid ${({ $active }) => ($active ? '#5C93FD' : '#D9D9D9')};
  box-shadow: 0px 2px rgba(0, 0, 0, 0.016);
  border-radius: 50%;
  width: 26px;
  height: 26px;
  margin-left: 10px;
`;
